import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Trigger = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.4335 2.09892C14.8496 2.2991 15.0746 2.75811 14.9778 3.20959L13.737 9.00006H19C19.3864 9.00006 19.7382 9.22266 19.9037 9.57183C20.0691 9.921 20.0186 10.3342 19.774 10.6333L10.774 21.6333C10.4816 21.9907 9.98255 22.1014 9.56648 21.9012C9.1504 21.701 8.92546 21.242 9.02221 20.7905L10.263 15.0001H5.00001C4.61362 15.0001 4.2618 14.7775 4.09634 14.4283C3.93088 14.0791 3.98138 13.6659 4.22605 13.3668L13.2261 2.36682C13.5184 2.00947 14.0175 1.89875 14.4335 2.09892ZM7.11025 13.0001H11.5C11.802 13.0001 12.0878 13.1365 12.2777 13.3714C12.4675 13.6062 12.5411 13.9143 12.4778 14.2096L11.8441 17.167L16.8898 11.0001H12.5C12.198 11.0001 11.9122 10.8636 11.7223 10.6287C11.5325 10.3939 11.4589 10.0858 11.5222 9.79053L12.1559 6.83311L7.11025 13.0001Z"
      fill="currentColor"
    />
  </Icon>
));

export default Trigger;
